import script from "./GeneratorField.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneratorField.vue?vue&type=script&setup=true&lang=js"

import "./GeneratorField.vue?vue&type=style&index=0&id=c2208bb2&scoped=true&lang=css"

import exportComponent from "C:\\Cwiczenia Programowanie Wojtek\\Vue Shop-FCC\\lang-cross\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2208bb2"]])

export default __exports__